import { ChatMessage } from './chat-message';
import { Region } from '../../shared/models';

export interface IThread {
    region: Region;
    messages: ChatMessage[];
    timestamp?: string;
}

export class Thread implements IThread {
    region: Region;
    messages: ChatMessage[];
    timestamp: string;

    constructor(region: Region) {
        this.region = region;
        this.messages = new Array<ChatMessage>();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/models/thread.ts